import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Copy = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3V23C4 23.5523 4.44772 24 5 24H19C19.5523 24 20 23.5523 20 23V3C20 2.44772 19.5523 2 19 2H5C4.44772 2 4 2.44772 4 3ZM18 22H6V4H18V22Z"
          fill="currentColor"
        />
        <path
          d="M10 28.3385V25.3385H12V27.3385H24.2462V9H21.2462V7H25.2462C25.7984 7 26.2462 7.44772 26.2462 8V28.3385C26.2462 28.8907 25.7984 29.3385 25.2462 29.3385H11C10.4477 29.3385 10 28.8907 10 28.3385Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Copy
